import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
/**
 * fc-tooltipæå­æç¤º
 * 
 * ç®åçæå­æç¤ºæ°æ³¡æ¡ã 
 * 
 * é¼ æ ç§»å¥åæ¾ç¤ºæç¤ºï¼ç§»åºæ¶å¤±ï¼æ°æ³¡æµ®å±ä¸æ¿è½½å¤æææ¬åæä½ã
 * 
 * å¯ç¨æ¥ä»£æ¿ç³»ç»é»è®¤çÂ titleÂ æç¤ºï¼æä¾ä¸ä¸ªæé®/æå­/æä½çææ¡è§£éã
 * 
 */
@Component({
    selector: 'fc-tooltip',
    template: `
        <span title="{{fcTitle}}">
            <ng-content select="[fccontent]"></ng-content>
        </span>
    `,
    styles: [`
    
    `]
})
export class FctooltipComponent extends FcComponent {
     /**æ é¢*/
    @Input()
    fcTitle: string;
     /**æ é¢ä½ç½®*/
    @Input()
    fcPosition: string;
     /** è§¦åæ¹å¼hover/focus/click*/
    @Input()
    fcTrigger: string;
     /**ç¨äºæå¨æ§å¶æµ®å±æ¾é*/
    @Input()
    fcVisible: string;
    _visible: boolean = false;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-tooltip');
        if (this.fcPosition === undefined) {
            this.fcPosition = "top";
        }
        if (this.fcTrigger === undefined) {
            this.fcTrigger = "hover";
        }
    }
}

